<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import { formatedDate } from "@/utils/proposalValidation";

export default {
  name: "FPTemp1",
  components: {
    SpellCheckedText,
    PhotoBox
  },
  props: {
	proposal:Object,
  },
  created() {
  		console.log('In FPTemp2 created');
		console.log(this.proposal);
	},
  methods: {
    formatedDate
  }
};
</script>

<template>
  <div class="main-container" :style="{
    '--header-color': proposal.style.colorScheme && proposal.style.colorScheme.header,
    '--body-color': proposal.style.colorScheme && proposal.style.colorScheme.body,
    '--footer-color': proposal.style.colorScheme && proposal.style.colorScheme.footer,
    '--heading-color': proposal.style.heading.color,
    '--heading-size': proposal.style.heading.size + 'px',
    '--heading-font': proposal.style.heading.font,
    '--heading-bold': proposal.style.heading.bold ? 700 : 400,
    '--heading-italic': proposal.style.heading.italic ? 'italic' : 'normal',
    '--heading-underline': proposal.style.heading.underline
      ? 'underline'
      : 'none',
    '--label-color': proposal.style.label.color,
    '--label-size': proposal.style.label.size + 'px',
    '--label-font': proposal.style.label.font,
    '--label-bold': proposal.style.label.bold ? 700 : 400,
    '--label-italic': proposal.style.label.italic ? 'italic' : 'normal',
    '--label-underline': proposal.style.label.underline
      ? 'underline'
      : 'none',
    '--text-color': proposal.style.text.color,
    '--text-size': proposal.style.text.size + 'px',
    '--text-font': proposal.style.text.font,
    '--text-bold': proposal.style.text.bold ? 700 : 400,
    '--text-italic': proposal.style.text.italic ? 'italic' : 'normal',
    '--text-underline': proposal.style.text.underline ? 'underline' : 'none',
  }">
    <div class="frontPage">
      <div class="header-sec">
        <div class="logo-sec photobox">
          <PhotoBox :project="proposal" type="logo" bgColor="transparent" objectFit="contain" />
        </div>
        <div class="banner top-banner"></div>
      </div>

      <div class="detail-sec">
        <p class="mb-5">
          <SpellCheckedText :value="proposal.name || ''" @input="proposal.name = $event" />
        </p>
        <p>
          <SpellCheckedText :value="proposal.address || ''" @input="proposal.address = $event" />
          <span>{{ proposal.address ? ', ' : '' }}</span>
          <SpellCheckedText :value="proposal.city || ''" @input="proposal.city = $event" />
          <span>{{ proposal.city ? ', ' : '' }}</span>
          <SpellCheckedText :value="proposal.stateProvince || ''" @input="proposal.stateProvince = $event" />
        </p>
      </div>

      <div class="submission-sec">
        <div>
          <h5>SUBMISSION DATE</h5>
          <p>
            {{ formatedDate(proposal.submissionDate, "/") }}
          </p>
        </div>

        <div>
          <h5>SUBMITTED BY</h5>
          <p>
            <SpellCheckedText :value="proposal.submittedBy || ''" @input="proposal.submittedBy = $event" />
          </p>
        </div>
      </div>

      <div class="banner bottom-banner"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-container {
  display: block;
  width: 211mm;
  height: 296.83mm;
  min-height: 296.83mm;
  position: relative;
  box-sizing: border-box;
  background: white;

  &:hover {
    .photobox :deep(.photo-overlay) {
      opacity: 1;
    }

    .photobox :deep(img) {
      opacity: 0.9;
    }
  }

  .frontPage {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .banner {
      min-height: 80px;

      &.top-banner {
        background: var(--header-color);
      }

      &.bottom-banner {
        background: var(--footer-color);
      }
    }

    .header-sec {
      display: grid;
      grid-template-columns: 1fr 3fr;
      gap: 20px;
      width: 100%;
      margin-bottom: 100px;

      .logo-sec {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--header-color);
        width: 193px;
        height: 80px;
      }
    }

    .detail-sec {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      padding: 80px;
      min-height: 450px;
      margin-bottom: 100px;
      background: var(--body-color);

      p {
        color: var(--heading-color);
        font-size: var(--heading-size);
        font-family: var(--heading-font);
        font-weight: var(--heading-bold);
        font-style: var(--heading-italic);
        text-decoration: var(--heading-underline);
      }
    }

    .submission-sec {
      display: flex;
      justify-content: space-between;
      background: white;
      padding: 80px;
      height: 100%;
      align-items: end;
      margin-top: auto;
      text-align: center;

      h5 {
        color: var(--label-color);
        font-size: var(--label-size);
        font-family: var(--label-font);
        font-weight: var(--label-bold);
        font-style: var(--label-italic);
        text-decoration: var(--label-underline);
      }

      p {
        color: var(--text-color);
        font-size: var(--text-size);
        font-family: var(--text-font);
        font-weight: var(--text-bold);
        font-style: var(--text-italic);
        text-decoration: var(--text-underline);
      }


    }
  }
}
</style>